var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"byeback"},[_c('the-head'),_c('br'),_c('br'),_c('the-buy-out'),_c('div',{staticClass:"text-center"},[_c('a',{staticClass:"byeback__btn",attrs:{"href":"https://www.istyle.cz/vykup-online"}},[_c('button',{staticClass:"white--text"},[_vm._v("Zpět")])])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }